import { render, staticRenderFns } from "./Gonggao.vue?vue&type=template&id=53a2987a&"
import script from "./Gonggao.vue?vue&type=script&lang=js&"
export * from "./Gonggao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports